export default __webpack_public_path__ + "static/media/headwind-logo.b73f8eb7.svg";